import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers';
import { parse, isValid } from 'date-fns';

import { DatePickerProps } from './types';
import { useDateTimePickerFormatter } from 'src/hooks/useDateTimePickerFormatter';

const DATE_FORMAT = 'yyyy-MM-dd';

export const DatePicker: React.FC<DatePickerProps> = ({
  handleDateChange,
  isDisabled,
  value,
  maximumEndDate,
  defaultCalendarMonth,
}) => {
  const initialCalendarMonth = defaultCalendarMonth ? new Date(defaultCalendarMonth) : undefined;

  const parsedValue = value ? parse(value, DATE_FORMAT, new Date()) : null;

  const dateValue = isValid(parsedValue) ? parsedValue : null;

  const [selectedDate, setSelectedDate] = useState<Date | null>(dateValue);

  useEffect(() => {
    setSelectedDate(dateValue);
  }, [value]);

  const handleChange = useDateTimePickerFormatter({
    setState: setSelectedDate,
    onChange: handleDateChange,
    formatPattern: DATE_FORMAT,
  });

  return (
    <MUIDatePicker
      inputFormat={DATE_FORMAT}
      value={selectedDate}
      onChange={handleChange}
      maxDate={maximumEndDate}
      defaultCalendarMonth={initialCalendarMonth}
      disableHighlightToday
      disablePast
      minDate={initialCalendarMonth}
      renderInput={props => (
        <TextField
          {...props}
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
              padding: '0px',
            },
          }}
        />
      )}
      disabled={isDisabled}
    />
  );
};
